import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@src/stores/index.js'

// 路由数据
import routes from '../routerConfig'

Vue.use(VueRouter)

let router = new VueRouter({
    mode:'history',
    routes
});
/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach((to,from,next)=>{
    console.log(to.params)
    if(to.matched.some(record=>record.meta.requiresAuth)){
        // 控制页面 登录 需要 requiresAuth
        if(!store.state.user.isLogin){
            store.commit('logout');
            window.pubsub&&window.pubsub.emit('logout');
            next({
                path:'/login?logout=true'
            })
        }
        else if(!window.workbench && to.path == '/callPatient' && localStorage.getItem('seatType') == 1){
            if(to.query.aliLogin) {
                next()
            }else {
                store.commit('logout');
                window.pubsub&&window.pubsub.emit('logout');
                next({
                    path:'/login?logout=true'
                })
            }
        }
        else{
            next()
        }
    }else{
        next()
    }
    if (to.path === '/workTable' && from.path === '/login') {
      to.params.fromLogin = true;
    }else {
        next();
    }
});



export default router;
